import Vue from 'vue'
import Router from 'vue-router'
import Main from '../components/main'

import Home from '../common/home'
import Product from '../components/product'
import Download from '../components/download'
import Newproduct from '../components/newproduct'
import Contact from '../components/contact'
import About from '../components/about'
import Introduce from'../components/Introduce'
import News from '../components/news'
import Exhibition from '../components/exhibition'
import Newsdetail from '../components/newsdetail'
import Exhibitiondetail from '../components/exhibitiondetail'
import Productdetail from '../components/productdetail'
import Productlist from '../components/productlist'
import Search from '../components/search'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: { name: 'home' },
      children:[
        { path: '/home', component:Home, name: 'home'},
        { path: '/product', component:Product, name: 'product',redirect: { name: 'productlist' },
        children:[
          { path: 'productlist', component:Productlist, name: 'productlist'},
          { path: 'productdetail', component:Productdetail, name: 'productdetail'},
        ]
        },
        { path: '/download', component:Download, name: 'download'},
        { path: '/newproduct', component:Newproduct, name: 'newproduct'},
        { path: '/contact', component:Contact, name: 'contact'},
        { path: '/search', component:Search, name: 'search'},
        { 
          path: '/about', component:About, name: 'about',redirect: { name: 'introduce' },
          children:[
            { path: 'introduce', component:Introduce, name: 'introduce'},
            { path: 'news', component:News, name: 'news'},
            { path: 'exhibition', component:Exhibition, name: 'exhibition'},
            { path: 'newsdetail', component:Newsdetail, name: 'newsdetail'},
            { path: 'exhibitiondetail', component:Exhibitiondetail, name: 'exhibitiondetail'},
          ]
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js